import { render } from "./StepDettagli.vue?vue&type=template&id=95aafcfe&scoped=true"
import script from "./StepDettagli.vue?vue&type=script&lang=js"
export * from "./StepDettagli.vue?vue&type=script&lang=js"

import "./StepDettagli.vue?vue&type=style&index=0&id=95aafcfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95aafcfe"]])

export default __exports__